import React, { useEffect } from "react";
import { Link } from "react-router-dom";
const Magazine = () => {
  useEffect(() => {
    document.title =
      "Magazine - Mar Gregorios Memorial Hr. Sec. School, Bokaro";
  }, []);
  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Academic</li>
          <li>Magazine</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Magazine</h1>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-12">
              <iframe
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/Harmonia_1_Magazine_2018.pdf"
                width="100%"
                height="1000px"
              ></iframe>
            </div>
          </div> */}
          <div className="row g-4">
            <div className="col-lg-4 col-md-6 col-12">
              <div className="magazine-card">
                <div className="magazine-icon">
                  <i className="bi bi-file-earmark-pdf-fill"></i>
                </div>
                <div className="magazine-content">
                  <h3>Magazine 2026</h3>
                  <p> FIREFLY- THE MGM GLIMMER 2026</p>
                  <a
                    href="https://drive.google.com/file/d/1P5tjB_7x__8ORLzAJc_WjWTXYj4yP1t4/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="view-magazine"
                  >
                    View Magazine
                    <i className="fa fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <div className="magazine-card">
                <div className="magazine-icon">
                  <i className="bi bi-file-earmark-pdf-fill"></i>
                </div>
                <div className="magazine-content">
                  <h3>Magazine 2018</h3>
                  <p> Harmonia Magazine • 2018</p>
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/Harmonia_1_Magazine_2018.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="view-magazine"
                  >
                    View Magazine
                    <i className="fa fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Magazine;
